/*
 *  Author: DL
 *  Date: 2020-12-04 12:13:39
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-10 19:18:18
 *  LastEditors: DL
 *  Description: 缩放控件
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useContext } from 'react';
import { BtnGroups, Icon } from 'ui';
import Control from '@/components/Control';
import Context from '@/hook/useFmapContext';

export default function() {
    const { fmap } = useContext(Context);

    const handleChangeZoom = type => {
        fmap.changeZoom(type);
    };

    return (
        <Control>
            <BtnGroups
                data={[
                    { text: <Icon className="iconzoomin" />, value: 'zoomIn' },
                    { text: <Icon className="iconjian1" />, value: 'zoomOut' },
                ]}
                onClick={handleChangeZoom}
            />
        </Control>
    );
}
